import { render, staticRenderFns } from "./activateCustomer.vue?vue&type=template&id=ec2cdee4&"
import script from "./activateCustomer.vue?vue&type=script&lang=js&"
export * from "./activateCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports